module.exports = __webpack_public_path__ + "img/icon_loading.630f9aa5.svg";